import { combineReducers } from 'redux';
import types from './types';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';

export interface ICreditCardError {
  hasFailed: boolean;
  message: string;
}

export interface ICreditCardSuccess {
  hasSucceed: boolean;
  message: string;
}

const INITIAL_SAVED_CARDS = [];
const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: ICreditCardError = {
  hasFailed: false,
  message: ''
};
const INITIAL_SUCCESS: ICreditCardSuccess = {
  hasSucceed: false,
  message: ''
};

const savedCards = (
  state: IInitialState['creditcard']['savedCards'] = INITIAL_STATE.creditcard
    .savedCards || [],
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_SAVED_CREDIT_CARDS: {
      return payload;
    }
    default:
      return state;
  }
};

const selectedCard = (
  state: IInitialState['creditcard']['selectedCard'] = INITIAL_STATE.creditcard
    .selectedCard || null,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_SELECTED_CARD: {
      return payload;
    }
    default:
      return state;
  }
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_CREDIT_CARD_IS_PENDING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const error = (
  state: ICreditCardError = INITIAL_ERROR,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_CREDIT_CARD_ERROR:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const success = (
  state: ICreditCardSuccess = INITIAL_SUCCESS,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_CREDIT_CARD_SUCCESS:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

export default combineReducers({
  savedCards,
  selectedCard,
  isPending,
  error,
  success
});
